import { useTranslation } from 'react-i18next';
import { Eyebrow } from 'shared/components/Eyebrow';
import { Heading } from 'shared/components/Heading';
import { RevealItem } from 'shared/components/RevealItem/RevealItem';
import { useScrollReveal } from 'shared/hooks/useScrollReveal';
import { HostCard } from '../components/HostCard/HostCard';
import { HOSTS } from "../hosts";

export const MeetTheHostsSection = () => {
  const { t } = useTranslation('about');
  const heading = useScrollReveal({ animation: 'float-up' });

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 mb-16 md:mb-32">
      <div ref={heading.ref} style={heading.style} className="text-center mb-10 md:mb-20">
        <Eyebrow className="tracking-[0.3em] mb-4 block">
          {t('hosts.label')}
        </Eyebrow>
        <Heading variant="section" className="text-5xl italic">{t('hosts.heading')}</Heading>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {HOSTS.map((host, i) => (
          <RevealItem key={host.name} index={i} className={i === 1 ? 'lg:mt-12' : ''}>
            <HostCard {...host} />
          </RevealItem>
        ))}
      </div>
    </section>
  )
}
